var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShow)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.saveCollect}},[_vm._v(_vm._s(_vm.isFavorite ? '已收藏' : '我要收藏'))]):_vm._e(),_c('dir-selector',{ref:"dirSelector",attrs:{"categoryType":"ResourceFavoriteDir"},on:{"ensure":_vm.ensure}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }